import BaseService from "src/packages/BaseService";

export default class GameQuestionService extends BaseService {
	static get className () {
		return "gamequestion";
	}

	static async reorder (data) {
		const response = await BaseService.getPublicService().post("/reorder", { data });
		return response.data;
	}
	/**
	 *  check if the question is belonged to more than the current game (game_id)
	 * @param question_id
	 * @param game_id
	 * @returns {*}
	 */
	static belongToAdditionalGames(question_id, game_id) {
		return BaseService.getPublicService().get(`/${this.className}/${game_id}/belongs_to_additional_games/${question_id}`);
	}
}
